module.exports = function stringify(x) {
  try { // handle "Converting circular structure to JSON" error
    return JSON.stringify(x, null, 2);
  }
  catch (e) {
    return String(x);
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/stringify.js
 ** module id = 479
 ** module chunks = 1
 **/